import React, { useEffect, useState } from "react";
import "./project2.css";

import youtube from "./youtube.svg"
import img1 from "./home.JPG";
import img2 from "./citySearch.png";
import img3 from "./login.JPG";
import img4 from "./signup.JPG";
import img5 from "./productDetails.png";
import img6 from "./orderSummary.png";

import left from "./left.gif";
import right from "./right.gif";

const Project2 = () => {
  const [current, setCurrent] = useState(0);
  const SliderData = [
    {
      id: 0,
      image: img1,
    },
    {
      id: 1,
      image: img2,
    },
    {
      id: 2,
      image: img3,
    },
    {
      id: 3,
      image: img4,
    },
    {
      id: 4,
      image: img5,
    },
    {
      id: 5,
      image: img6,
    },
  ];

  // useEffect(() => {
  //   setInterval(() => {
  //    setCurrent(prev=>prev+1)
  //   },1000)
  // },[])

  const length = SliderData.length;

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  // if (!Array.isArray(SliderData) || SliderData.length <= 0) {
  //   return null;
  // }

  return (
    <div className="project1body">
      <div className="slider">
        <img src={left} className="left_arrow" onClick={prevSlide} />
        <img src={right} className="right_arrow" onClick={nextSlide} />
        {SliderData.map((slide) => {
          return (
            slide.id == current && (
              <div className="imageediv" key={slide.id}>
                <img className="proimg" src={slide.image} alt="img"></img>
              </div>
            )
          );
        })}
      </div>

      <div className="procontentdiv">
        <h2
          style={{
            textAlign: "center",

            fontWeight: "bolder",
          }}
        >
          Royal Brothers Clone
        </h2>
        <p>
        Royal brother is a bike rentals platform to rent bikes on hourly basis.
       ‘Why buy when you can rent’
        
        </p>

        <h3 style={{ color: "#B37D4E" }}>Tech stack:</h3>
        <p>React | Redux | Material UI | MongoDB | Express JS | Node JS | HTML | CSS</p>

        <div className="btndivv">
          <button className="btnpro" style={{ backgroundColor: "black" }}>
            <a
              style={{ textDecoration: "none", color: "white" }}
              target="_blank"
              href="https://github.com/sahilgarg29/royalbrothers-frontend"
            >
              <span>
                <svg
                  style={{
                    color: "white",
                    marginTop: "5px",
                    position: "absolute",
                    left: "10",
                    bottom: "6",
                  }}
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 496 512"
                  height="1.1em"
                  width="1.1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"></path>
                </svg>
              </span>
              code
            </a>
          </button>

          <button
            className="btnpro"
            style={{ backgroundColor: "#286DAB" }}
          >
            <a
              href="https://royalbrothers-clone.netlify.app/"
              style={{ textDecoration: "none", color: "white" }}
              target="_blank"
            >
              <span>
                <svg
                  style={{
                    color: "white",
                    marginTop: "5px",
                    position: "absolute",
                    left: "10",
                    bottom: "6",
                  }}
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 24 24"
                  height="1.1em"
                  width="1.1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M13 3L16.293 6.293 9.293 13.293 10.707 14.707 17.707 7.707 21 11 21 3z"></path>
                  <path d="M19,19H5V5h7l-2-2H5C3.897,3,3,3.897,3,5v14c0,1.103,0.897,2,2,2h14c1.103,0,2-0.897,2-2v-5l-2-2V19z"></path>
                </svg>
              </span>
              Live
            </a>
          </button>

          {/* yt */}
          <button className="btnpro" style={{ backgroundColor: "red" }}>
            <a
              className="anch"
              style={{ textDecoration: "none", color: "white" }}
              target="_blank"
              href="https://drive.google.com/file/d/1ktZ3qkjW9SIiZENNRv9Tyd8iDj14TLzU/view?usp=sharing"
            >
              <span>
                <img
                  src={youtube}
                  style={{
                    color: "white",
                    marginTop: "-2px",
                    position: "absolute",
                    left: "0",

                    width: "1.5em",
                    height: "1.5em",
                    marginLeft: "8px",
                  }}
                ></img>
              </span>
              Demo
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Project2;
